module.exports = __webpack_public_path__ + "static/img/product03-2.ad44655b.png";